export default __webpack_public_path__ + "static/media/DuerfpLightActive.4024294a.svg";